import { create } from 'zustand';

interface ChangePasswordForm {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

interface ChangePasswordStore {
  isSubmitting: boolean;
  form: ChangePasswordForm;
  setIsSubmitting: (isSubmitting: boolean) => void;
  setForm: (form: Partial<ChangePasswordForm>) => void;
  reset: () => void;
}

const initialForm: ChangePasswordForm = {
  currentPassword: '',
  newPassword: '',
  confirmPassword: '',
};

export const useChangePasswordStore = create<ChangePasswordStore>((set, get) => ({
  isSubmitting: false,
  form: initialForm,
  setIsSubmitting: (isSubmitting) => set({ isSubmitting }),
  setForm: (updates) => set({ form: { ...get().form, ...updates } }),
  reset: () => set({ isSubmitting: false, form: initialForm }),
}));
